<template>
  <b-container class="contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('user.payment.viewtitle')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col lg="12">
        <h3>{{$t('user.payment.addinformation')}}</h3>
        <p>{{$t('user.payment.intro')}}</p>
      </b-col>
    </b-row>
    <b-row align-h="between">
      <b-col lg="5">
        <b-form-group label="Card Holder">
          <input type="card-holder-name" class="form-control" placeholder="Card Holder" id="card-holder-name" v-model="holder"/>
        </b-form-group>
        <b-form-group label="Credit Card Information">
          <div id="card-element">
            <!-- A Stripe Element will be inserted here. -->
          </div>
        </b-form-group>
        <button class="btn btn--green" id="card-button" v-bind:data-secret="intent" v-on:click="addCard">{{$t('user.payment.submitcard')}}</button>
      </b-col>
      <b-col lg="5">
        <img src="/images/creditcardmockup.svg" class="creditcardmockup mb-3 w-100" alt="">
        <div v-html="$t('user.payment.differentpaymentnote')"></div>
      </b-col>
  </b-row>
  </b-container>
</template>

<script>

import { mapMutations } from 'vuex'
import { STRIPE_KEY } from '../../common/config'

export default {

  name: 'payment',

  computed: {
    validCreditCard () {
      return this.account.stripe_id !== ''
    }
  },

  data () {
    return {
      account: {},
      intent: {},
      edit: false,
      stripe: {},
      holder: '',
      elements: {},
      cardElement: {}
    }
  },

  methods: {

    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'endLoading'
    ]),

    addCard () {
      this.stripe.handleCardSetup(
        this.intent, this.cardElement, {
          payment_method_data: {
            billing_details: { name: this.holder }
          }
        }
      ).then((result) => {
        if (result.error) {
          alert('An error occured: ' + result.error.message)

          return
        }

        const payload = {
          type: 'CC',
          payment_method: result.setupIntent.payment_method
        }

        this.axios.post('/api/account/updatepaymentmethod', payload).then(() => {
          this.$router.push({
            name: 'userPayment'
          })
        })
      })
    }
  },

  mounted () {
    let style = {
      base: {
        border: '1px solid #D8D8D8',
        borderRadius: '4px',
        color: '#000'
      },

      invalid: {
        // All of the error styles go inside of here.
      }

    }

    this.stripe = window.Stripe(STRIPE_KEY)
    this.elements = this.stripe.elements()
    this.cardElement = this.elements.create('card', { style: style })
    this.cardElement.mount('#card-element')
  },

  created () {
    this.setViewname(this.$t('user.paymentaddcard.viewtitle'))

    this.axios.get('/api/account').then(
      response => {
        this.account = response.data.data
      }
    )

    this.axios.get('/api/account/updatepayment').then(
      response => {
        this.intent = response.data[0]
        this.endLoading()
      }
    )
  }
}
</script>
